<template>
  <div id="Opportunities_Experiental-Learning">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc"
      :color="this.page.color"></usc-hero>

    <usc-intro>
      <!-- <usc-cta slot="cta" text="Explore the ELC" url="https://www.marshall.usc.edu/programs/experiential-learning-center/what-we-do"></usc-cta> -->
      <p slot="p">The most beneficial learning allows you to blend what you study in class with how it will apply in the real world during your career. At Marshall, we ensure you leave our programs armed with hands-on experiences that deeply instill the critical-thinking, communications and collaborative skills you will need to launch successful careers in any field you choose. You’ll learn by doing — in the classroom, in our specialized learning centers, and through internships and student organizations.</p>
    </usc-intro>

    <div class="body gutter-lg">
      <p><i>Not only is our curriculum infused with meaningful experiential learning exercises, but you will also have
          plentiful opportunities for immersive learning through our pioneering Experiential Learning Center,
          Brittingham Social Enterprise Lab, a student investment fund and other unique programs as well as case
          competitions.</i></p>
      <p><strong>Experiential Learning Center</strong><br />
        The nation’s first applied learning program of its kind, Marshall’s Experiential Learning Center (ELC) is a
        behavioral laboratory in which students participate in business simulations that mimic real-life work settings.
        Considered to be one of the top training facilities in institutions of higher education, ELC employs
        professional trainers who conduct management training workshops for Marshall classes.
      </p>
      <p>ELC trainers work closely with faculty from various departments to ensure that the appropriate and specific
        educational objectives are met. Training modules at the ELC cover leadership, communication, intercultural
        interactions, business strategy, business ethics, social responsibility, negotiation, management consulting and
        a host of other topics relevant to business education. ELC employs both “face-to-face” and immersive and
        interactive methods of instruction that expose every Marshall student to the concepts of “learning by doing” and
        “learning by active engagement.”</p>
      <p>ELC consists of 18 fully equipped studios that facilitate recording and capture of training sessions and
        presentations. More than 60 Marshall courses and hundreds of classes use ELC services each year.</p>
    </div>
    <usc-videoEmbed :frameTitle="this.video1.frameTitle" :caption="this.video1.caption" :videoSource="this.video1.src"></usc-videoEmbed>
    <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed>
    <div class="body gutter-lg">
      <p>

        <p><strong>Brittingham Social Enterprise Lab</strong><br />
          At the forefront of pioneering education to train the next generation of social entrepreneurs, Marshall’s
          Brittingham Social Enterprise Lab integrates the best of business and social thinking to address world
          problems. It applies new models for social involvement to the corporate world and trains the next generation
          of responsible business leaders while providing a base for related academic research.
        </p>
        <p>
          The lab incorporates a bridging program, the first of its kind at a university business school, that creates
          new models enabling corporations to use their non-cash resources for the benefit of communities around the
          world. It also offers coursework in social responsibility, social enterprise and ethics; coordinates USC
          Marshall student and faculty nonprofit consulting efforts; and supports faculty research.
        </p>
        <p>
          <strong>Undergraduate Student Investment Fund</strong><br />
          The Undergraduate Student Investment Fund is a primary function of Marshall’s capstone investment management
          course, Advanced Practicum in Portfolio Management. The course offers a yearlong experiential-learning seminar
          in applied investment management designed to give students rigorous exposure to contemporary investment and
          portfolio theory and practice. It also enables you to learn the skills of actual money managers, presenting
          the analytical framework and tools for valuation of stocks, bonds, options, futures, risk management and
          portfolio optimization and performance attribution. In addition, behavioral finance is introduced. Students
          demonstrate and refine their understanding and ability to apply analytical concepts and techniques through
          fund management, industry reports, company research reports and stock pitching exercises.
        </p>
        <p>
          <strong>Case Competitions</strong><br />
          In case competitions, undergraduate student teams from top business schools around the world compete against
          each other under deadline conditions to develop solutions for real-life business problems.
        </p>
        <p>
          Participation in the five-day USC Marshall International Case Competition, the largest international case
          competition in the world, is both an honor and a supreme challenge. Students are chosen for the team on the
          basis of their familiarity with business fundamentals, understanding of complex international business issues
          and strong analytical-reasoning and presentation skills.
        </p>
        <p>
          Each team has just 20 minutes to present its analysis and recommendations. Teams are judged by a panel of
          industry experts, including CEOs, top management executives, consultants and academics.
        </p>
        <p>
          USC Marshall also participates in — and often wins — undergraduate case competitions around the world. We’ve recently fielded student teams at competitions in Copenhagen, Montreal and Singapore.
        </p>
        <p>
          <strong>Supporting Budding Entrepreneurs</strong><br />
          Marshall is also home to the pioneering Lloyd Greif Center for Entrepreneurial Studies, featuring the mentors,
          classes and support needed to launch new ventures in whatever field you choose. The competitive but inclusive
          USC Marshall/Greif Incubator takes budding entrepreneurs through every step in turning fresh ideas into
          marketable products.
        </p>
        <p><img src="../../../static/info-ADVANTAGES-experiential-learning.png" alt="1st: Marshall is home to the nation's first integrated entrepreneurship program. 1st: Marshall created the first social entreprise academic center. 100+: Number of startups accepted by the Marshall Incubator. 80+: Course sections on entreprenurship. $150k: Annual New Venture Seed Competition prize pool." title="1st: Marshall is home to the nation's first integrated entrepreneurship program. 1st: Marshall created the first social entreprise academic center. 100+: Number of startups accepted by the Marshall Incubator. 80+: Course sections on entreprenurship. $150k: Annual New Venture Seed Competition prize pool." style="width: 100%;"/></p>
    </div>
  </div>
</template>

<script>
  import hero from '@/components/Hero'
  import intro from '@/components/Intro'
  import Cta from '@/components/Cta'
  import videoEmbed from '@/components/videoEmbed'
  import table from '@/components/Table'
  import ListImage from '@/components/ListImage'
  import DataViz from '@/components/DataViz'

  export default {
    name: 'ExperientialLearning',
    components: {
      'usc-hero': hero,
      'usc-intro': intro,
      'usc-cta': Cta,
      'usc-videoEmbed': videoEmbed,
      'usc-table': table,
      'usc-list-img': ListImage,
      'usc-dataviz': DataViz
    },
    data () {
      return {
        page: {
          color: '#ffcc00'
        },
        hero: {
          title: 'Experiential Learning',
          loResSrc: '../../../static/HeroImages/Advantages-Marshall6.jpg',
          hiResSrc: '../../../static/HeroImages/Advantages-Marshall6.jpg'
        },
        video: {
          caption: 'The Next 100 Years',
          src: 'https://player.vimeo.com/video/668392133',
          frameTitle: 'Video: The Next 100 Years'
        },
        video1: {
          caption: 'USC Marshall Experiential Learning Center',
          src: 'https://player.vimeo.com/video/210511467',
          frameTitle: 'USC Marshall Experiential Learning Center'
        }
      }
    },
    created () {
      this.$root.setPageHeader('Opportunities', 'Experiential Learning')
    }
  }
</script>

<style scoped lang="scss">
  @import '~tiny-slider/src/tiny-slider';

  img {
    max-width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/pages/advantages/ExperientialLearning.vue